import styled from 'styled-components';
import {
  ProductLinkedProductsValuesAttribute,
  ProductTextValuesAttribute,
} from 'src/models/pim/attributes';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { Paragraph } from 'src/components/common/typography/Text';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { ProductPageProtocolsSessionsItemProduct } from 'src/modules/products/components/ProductPage/ProductPageProtocolsSessions/ProductPageProtocolsSessionsItemProduct';

export interface ProductPageProtocolsSessionsItemProps {
  title: ProductTextValuesAttribute['item'] | undefined;
  description: ProductTextValuesAttribute['item'] | undefined;
  items: ProductLinkedProductsValuesAttribute['item']['value'] | null;
  index: number;
}

const Heading = styled.h3`
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
`;

const Container = styled.div<{ $singular?: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 430px;
  gap: 16px;
`;

const IndexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  font-size: 40px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.palette.accent};
`;

const IndexLine = styled.div`
  position: relative;
  width: 100%;
  height: 1rpx;
  background: ${({ theme }) => theme.text.palette.accent};
  &:after,
  &:before {
    content: '';
    position: absolute;
    right: 0;
    width: 7rpx;
    height: 2rpx;
    background: ${({ theme }) => theme.text.palette.accent};
  }
  &:before {
    top: -3rpx;
    transform: rotate(45deg);
  }
  &:after {
    top: 2rpx;
    transform: rotate(-45deg);
  }
`;

export const ProductPageProtocolsSessionsItem = ({
  title,
  description,
  items,
  index,
}: ProductPageProtocolsSessionsItemProps) => {
  const translateFn = useTranslateItem();

  return (
    <Container>
      <IndexContainer>
        0{index} <IndexLine />
      </IndexContainer>

      {title && (
        <Heading>
          <Markdown>{translateFn(title).value}</Markdown>
        </Heading>
      )}

      {description && (
        <Paragraph>
          <Markdown>{translateFn(description).value}</Markdown>
        </Paragraph>
      )}

      {items?.map((item, index) => (
        <ProductPageProtocolsSessionsItemProduct key={index} {...item} />
      ))}
    </Container>
  );
};
